/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CardData
 */
export interface CardData {
    /**
     * 
     * @type {string}
     * @memberof CardData
     */
    cardNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardData
     */
    expiration?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CardData
     */
    brand?: string | null;
}

/**
 * Check if a given object implements the CardData interface.
 */
export function instanceOfCardData(value: object): value is CardData {
    return true;
}

export function CardDataFromJSON(json: any): CardData {
    return CardDataFromJSONTyped(json, false);
}

export function CardDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardData {
    if (json == null) {
        return json;
    }
    return {
        
        'cardNumber': json['cardNumber'] == null ? undefined : json['cardNumber'],
        'expiration': json['expiration'] == null ? undefined : json['expiration'],
        'brand': json['brand'] == null ? undefined : json['brand'],
    };
}

export function CardDataToJSON(json: any): CardData {
    return CardDataToJSONTyped(json, false);
}

export function CardDataToJSONTyped(value?: CardData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cardNumber': value['cardNumber'],
        'expiration': value['expiration'],
        'brand': value['brand'],
    };
}

